const INITIAL_STATE = {
    notificacoesPush: [],
    notificacaoPush: {},
    loading: false,
    processing: false,
    uploadedFiles: [],
    existingFiles: [],
}

export default function NotificacoesPush(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'NOTIFICACOES_PUSH_FETCHED' :
            return { ...state, notificacoesPush: action.payload }
        case 'NOTIFICACAO_PUSH_FETCHED' :
            return { ...state, notificacaoPush: action.payload }
        case 'NOTIFICACOES_PUSH_LOADING' :
            return { ...state, loading: action.payload }
        case 'NOTIFICACOES_PUSH_PROCESSING' :
            return { ...state, processing: action.payload }
        case 'UPLOADED_FILES' :
            return { ...state, uploadedFiles: action.payload }
        case 'EXISTING_FILES' :
            return { ...state, existingFiles: action.payload }
        case 'UPDATE_UPLOADED_FILES':
            const data = action.payload;
            const { uploadedFiles } = state;
            const uploadingFiles = uploadedFiles.map(file => {
                return data.idTemp === file.idTemp ? { ...file, ...data } : file;
            })
            return { ...state, uploadedFiles: uploadingFiles }
        case 'DELETE_UPLOADED_FILE':
            const id = action.payload;
            const files = state.uploadedFiles.filter(file => file.id !== id);
            return { ...state, uploadedFiles: files }
        default :
            return state
    }
}